import { createModal, Tooltip } from '@thermon-platforms/thermon-ui-core';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import useUsersStore from 'store/users';
import useRolesStore from 'store/roles';
import Modal from './modal';

function Button({device}) {
  const [, usersStoreActions] = useUsersStore();
  const [rolesStore] = useRolesStore();

  if (!usersStoreActions.checkAccess('CanChangeConfiguration', rolesStore.roles)) return null;

  function viewImages() {
    const imagesModal = createModal(<Modal device={device} />);
    imagesModal.open();
  }

  return (<>
    <button
      className="iso"
      data-tooltip-content={t`ISOs`}
      data-tooltip-id="images-tooltip"
      onClick={viewImages}
    >
      <Trans>ISOs</Trans>
    </button>
    <Tooltip id="images-tooltip" place="bottom-end" />
  </>)
}

export default Button;
